import common from './common'
import tools from './tools' //工具
import http from './ajax'
let weixin = (function () {
  return {
    default: {
      title: '',
      desc: '',
      href: location.href,
    },
    hideMenu() {
      //隐藏微信地址栏自带工具栏
      if (!tools.isWeiXin()) return;
      this.getJssdk(function (data) {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: common.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名，见附录1
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'updateTimelineShareData', 'updateAppMessageShareData', , 'hideAllNonBaseMenuItem', 'showMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideAllNonBaseMenuItem();
        });
        wx.error(function (res) {
          console.log(res);
          // alert(JSON.stringify(res));
        });
      })
    },
    //获取地址栏参数
    getQueryStringByName: function (name) {
      var result = location.search.match(new RegExp("[\?\&]" + name + "=([^\&]+)", "i"));
      if (result == null || result.length < 1) {
        return "";
      }
      return result[1];
    },
    //获取微信授权地址
    wechat_redirect_url: function () {
      var wxappid = common.appId; //appid
      var fromurl = '';
      var tempHref = location.href;
      var authText = "snsapi_userinfo";
      // var authText = "snsapi_base";
      // if(params.openModal){
      //   authText = "snsapi_userinfo";
      // }
      //如果当前访问域名不在安全域名内,则跳转到个人中心的登录跳转页
      fromurl = encodeURIComponent(tempHref);
      const commponentAppid = common.commponentAppid
      let url = ''
      url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + wxappid + '&redirect_uri='
        + fromurl + '&response_type=code&scope=' + authText + '&state=' + authText + '&connect_redirect=1#wechat_redirect';

      return url;
    },
    login: function () {
      var code = this.getQueryStringByName('code');
      var state = this.getQueryStringByName('state');
      if (!code) {
        var redirect_url = this.wechat_redirect_url();//获取授权地址
        window.location.replace(redirect_url);
      } else {
        http({
          url: '/api/wx/userInfo',
          type: "GET",
          hideAlert: true,
          data: {
            code: code,
            state: state,
          }
        }).then((result, er) => {
          console.log(result,'微信授权返回数据');
          if (result.httpCode != 1) {
            var redirect_url = this.wechat_redirect_url();//获取授权地址
            window.location.replace(redirect_url);
            return;
          }
          if (result.data) {
            localStorage.setItem("openid", result.data);
          }
        });
      }
    },
  }
})()


export default weixin
